module.exports = __webpack_public_path__ + "static/img/bg.496c177f.svg";